// Custom read more and less functions
function readMore(clicked_id){
	let clickedButtonNumber = clicked_id.split('read-button-open');
    let openButton = document.getElementById(clicked_id);

    let textContainerId = 'read-more'+clickedButtonNumber[1];
    let textContainer = document.getElementById(textContainerId);

    openButton.classList.toggle('closed');
    textContainer.classList.toggle('closed');
}

function readLess(clicked_id){
    let clickedButtonNumber = clicked_id.split('read-button-close');

    let openButtonId = 'read-button-open' + clickedButtonNumber[1];
    let openButton = document.getElementById(openButtonId);

    let textContainerId = 'read-more'+clickedButtonNumber[1];
    let textContainer = document.getElementById(textContainerId);

    openButton.classList.toggle('closed');
    textContainer.classList.toggle('closed');
}

function read_more(button){
    let target = button.dataset.target;
  	let container= document.getElementsByClassName(target)[0];

    container.classList.toggle('closed');
    button.classList.toggle('closed');
}
  
function read_less(clicked_button){
    let target = clicked_button.dataset.target;
  	let container= document.getElementsByClassName(target)[0];
    let readMoreButton = document.getElementById(target);
    container.classList.toggle('closed');
    readMoreButton.classList.toggle('closed');
}